
import { inject, Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { NavigateService } from '@shared/services/navigate.service';
import { SnackBarService } from '@core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { RedirectHelper } from '@shared/helpers/redirect-helper';

@Injectable({ providedIn: 'root' })
export class CompanyPanelGuard  {
  private readonly store = inject(StorageService);
  private readonly n = inject(NavigateService);
  private readonly s = inject(SnackBarService);
  private readonly t = inject(TranslateService);

  canActivate(route?, state?) {
    if (!!this.store?.jwt && !!this.store?.UserPerson) {
      if (!this.store.Employee?.id) {
        this.n.navigate('company-selection');
        return false;
      }
      return true;
    }

    this.s.error(this.t.instant('Auth.Errors.permissionsDenied'));
    this.n.navigate('login', { redirectTo: RedirectHelper.getWindowPath() });
    return false;
  }

  canActivateChild(route?, state?) {
    return this.canActivate(route, state);
  }
}
